export function getAsinsFromSelectedProducts(
  selectedProductToCompare: any[],
): string[] {
  return (selectedProductToCompare ?? [])
    .map((item) => item?.asin)
    .filter(Boolean) as string[];
}

export function findMatchingAspects(originalAspectsStats, compareAspectsStats) {
  if (!originalAspectsStats?.length || !compareAspectsStats?.length) {
    return [[], null];
  }

  const allCompareAspects = new Set<string>();
  compareAspectsStats.forEach((item) => {
    item.items.forEach((aspect) => {
      allCompareAspects.add(aspect.aspect);
    });
  });

  const matchingAspects = originalAspectsStats.filter((item) =>
    allCompareAspects.has(item.aspect),
  );

  const combinedCompare = combineCompareAspects(
    compareAspectsStats,
    matchingAspects.map((a) => a.aspect),
  );

  return [matchingAspects, combinedCompare];
}

export function combineCompareAspects(compareAspectsStats, aspectsToInclude) {
  const aspectTotals: Record<string, { sum: number; count: number }> = {};
  aspectsToInclude.forEach((aspect) => {
    aspectTotals[aspect] = { sum: 0, count: 0 };
  });

  compareAspectsStats.forEach((product) => {
    product.items.forEach((item) => {
      if (aspectsToInclude.includes(item.aspect)) {
        aspectTotals[item.aspect].sum += item.avg;
        aspectTotals[item.aspect].count += 1;
      }
    });
  });

  return Object.entries(aspectTotals).map(([aspect, { sum, count }]) => ({
    aspect,
    avg: count > 0 ? sum / count : 0,
  }));
}
